export const CountryCodes: Record<string, string> = {
  AFG: '4',
  ALB: '8',
  DZA: '12',
  ASM: '16',
  AND: '20',
  AGO: '24',
  AIA: '660',
  ATA: '10',
  ATG: '28',
  ARG: '32',
  ARM: '51',
  ABW: '533',
  AUS: '36',
  AUT: '40',
  AZE: '31',
  BHS: '44',
  BHR: '48',
  BGD: '50',
  BRB: '52',
  BLR: '112',
  BEL: '56',
  BLZ: '84',
  BEN: '204',
  BMU: '60',
  BTN: '64',
  BOL: '68',
  BES: '535',
  BIH: '70',
  BWA: '72',
  BVT: '74',
  BRA: '76',
  IOT: '86',
  BRN: '96',
  BGR: '100',
  BFA: '854',
  BDI: '108',
  CPV: '132',
  KHM: '116',
  CMR: '120',
  CAN: '124',
  CYM: '136',
  CAF: '140',
  TCD: '148',
  CHL: '152',
  CHN: '156',
  CXR: '162',
  CCK: '166',
  COL: '170',
  COM: '174',
  COD: '180',
  COG: '178',
  COK: '184',
  CRI: '188',
  HRV: '191',
  CUB: '192',
  CUW: '531',
  CYP: '196',
  CZE: '203',
  CIV: '384',
  DNK: '208',
  DJI: '262',
  DMA: '212',
  DOM: '214',
  ECU: '218',
  EGY: '818',
  SLV: '222',
  GNQ: '226',
  ERI: '232',
  EST: '233',
  SWZ: '748',
  ETH: '231',
  FLK: '238',
  FRO: '234',
  FJI: '242',
  FIN: '246',
  FRA: '250',
  GUF: '254',
  PYF: '258',
  ATF: '260',
  GAB: '266',
  GMB: '270',
  GEO: '268',
  DEU: '276',
  GHA: '288',
  GIB: '292',
  GRC: '300',
  GRL: '304',
  GRD: '308',
  GLP: '312',
  GUM: '316',
  GTM: '320',
  GGY: '831',
  GIN: '324',
  GNB: '624',
  GUY: '328',
  HTI: '332',
  HMD: '334',
  VAT: '336',
  HND: '340',
  HKG: '344',
  HUN: '348',
  ISL: '352',
  IND: '356',
  IDN: '360',
  IRN: '364',
  IRQ: '368',
  IRL: '372',
  IMN: '833',
  ISR: '376',
  ITA: '380',
  JAM: '388',
  JPN: '392',
  JEY: '832',
  JOR: '400',
  KAZ: '398',
  KEN: '404',
  KIR: '296',
  PRK: '408',
  KOR: '410',
  KWT: '414',
  KGZ: '417',
  LAO: '418',
  LVA: '428',
  LBN: '422',
  LSO: '426',
  LBR: '430',
  LBY: '434',
  LIE: '438',
  LTU: '440',
  LUX: '442',
  MAC: '446',
  MDG: '450',
  MWI: '454',
  MYS: '458',
  MDV: '462',
  MLI: '466',
  MLT: '470',
  MHL: '584',
  MTQ: '474',
  MRT: '478',
  MUS: '480',
  MYT: '175',
  MEX: '484',
  FSM: '583',
  MDA: '498',
  MCO: '492',
  MNG: '496',
  MNE: '499',
  MSR: '500',
  MAR: '504',
  MOZ: '508',
  MMR: '104',
  NAM: '516',
  NRU: '520',
  NPL: '524',
  NLD: '528',
  NCL: '540',
  NZL: '554',
  NIC: '558',
  NER: '562',
  NGA: '566',
  NIU: '570',
  NFK: '574',
  MKD: '807',
  MNP: '580',
  NOR: '578',
  OMN: '512',
  PAK: '586',
  PLW: '585',
  PSE: '275',
  PAN: '591',
  PNG: '598',
  PRY: '600',
  PER: '604',
  PHL: '608',
  PCN: '612',
  POL: '616',
  PRT: '620',
  PRI: '630',
  QAT: '634',
  ROU: '642',
  RUS: '643',
  RWA: '646',
  REU: '638',
  BLM: '652',
  SHN: '654',
  KNA: '659',
  LCA: '662',
  MAF: '663',
  SPM: '666',
  VCT: '670',
  WSM: '882',
  SMR: '674',
  STP: '678',
  SAU: '682',
  SEN: '686',
  SRB: '688',
  SYC: '690',
  SLE: '694',
  SGP: '702',
  SXM: '534',
  SVK: '703',
  SVN: '705',
  SLB: '90',
  SOM: '706',
  ZAF: '710',
  SGS: '239',
  SSD: '728',
  ESP: '724',
  LKA: '144',
  SDN: '729',
  SUR: '740',
  SJM: '744',
  SWE: '752',
  CHE: '756',
  SYR: '760',
  TWN: '158',
  TJK: '762',
  TZA: '834',
  THA: '764',
  TLS: '626',
  TGO: '768',
  TKL: '772',
  TON: '776',
  TTO: '780',
  TUN: '788',
  TKM: '795',
  TCA: '796',
  TUV: '798',
  TUR: '792',
  UGA: '800',
  UKR: '804',
  ARE: '784',
  GBR: '826',
  UMI: '581',
  USA: '840',
  URY: '858',
  UZB: '860',
  VUT: '548',
  VEN: '862',
  VNM: '704',
  VGB: '92',
  VIR: '850',
  WLF: '876',
  ESH: '732',
  YEM: '887',
  ZMB: '894',
  ZWE: '716',
  ALA: '248',
};

export const CountryCodeNames: Record<string, string> = {
  AFG: 'Afghanistan',
  ALB: 'Albania',
  DZA: 'Algeria',
  ASM: 'American Samoa',
  AND: 'Andorra',
  AGO: 'Angola',
  AIA: 'Anguilla',
  ATA: 'Antarctica',
  ATG: 'Antigua and Barbuda',
  ARG: 'Argentina',
  ARM: 'Armenia',
  ABW: 'Aruba',
  AUS: 'Australia',
  AUT: 'Austria',
  AZE: 'Azerbaijan',
  BHS: 'Bahamas',
  BHR: 'Bahrain',
  BGD: 'Bangladesh',
  BRB: 'Barbados',
  BLR: 'Belarus',
  BEL: 'Belgium',
  BLZ: 'Belize',
  BEN: 'Benin',
  BMU: 'Bermuda',
  BTN: 'Bhutan',
  BOL: 'Bolivia',
  BES: 'Bonaire, Sint Eustatius and Saba',
  BIH: 'Bosnia and Herzegovina',
  BWA: 'Botswana',
  BVT: 'Bouvet Island',
  BRA: 'Brazil',
  IOT: 'British Indian Ocean Territory',
  BRN: 'Brunei Darussalam',
  BGR: 'Bulgaria',
  BFA: 'Burkina Faso',
  BDI: 'Burundi',
  CPV: 'Cabo Verde',
  KHM: 'Cambodia',
  CMR: 'Cameroon',
  CAN: 'Canada',
  CYM: 'Cayman Islands',
  CAF: 'Central African Republic',
  TCD: 'Chad',
  CHL: 'Chile',
  CHN: 'China',
  CXR: 'Christmas Island',
  CCK: 'Cocos (Keeling) Islands',
  COL: 'Colombia',
  COM: 'Comoros',
  COD: 'Congo, Democratic Republic of the',
  COG: 'Congo',
  COK: 'Cook Islands',
  CRI: 'Costa Rica',
  HRV: 'Croatia',
  CUB: 'Cuba',
  CUW: 'Curaçao',
  CYP: 'Cyprus',
  CZE: 'Czechia',
  CIV: 'Côte d’Ivoire',
  DNK: 'Denmark',
  DJI: 'Djibouti',
  DMA: 'Dominica',
  DOM: 'Dominican Republic',
  ECU: 'Ecuador',
  EGY: 'Egypt',
  SLV: 'El Salvador',
  GNQ: 'Equatorial Guinea',
  ERI: 'Eritrea',
  EST: 'Estonia',
  SWZ: 'Eswatini',
  ETH: 'Ethiopia',
  FLK: 'Falkland Islands (Malvinas)',
  FRO: 'Faroe Islands',
  FJI: 'Fiji',
  FIN: 'Finland',
  FRA: 'France',
  GUF: 'French Guiana',
  PYF: 'French Polynesia',
  ATF: 'French Southern Territories',
  GAB: 'Gabon',
  GMB: 'Gambia',
  GEO: 'Georgia',
  DEU: 'Germany',
  GHA: 'Ghana',
  GIB: 'Gibraltar',
  GRC: 'Greece',
  GRL: 'Greenland',
  GRD: 'Grenada',
  GLP: 'Guadeloupe',
  GUM: 'Guam',
  GTM: 'Guatemala',
  GGY: 'Guernsey',
  GIN: 'Guinea',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HTI: 'Haiti',
  HMD: 'Heard Island and McDonald Islands',
  VAT: 'Holy See',
  HND: 'Honduras',
  HKG: 'Hong Kong',
  HUN: 'Hungary',
  ISL: 'Iceland',
  IND: 'India',
  IDN: 'Indonesia',
  IRN: 'Iran',
  IRQ: 'Iraq',
  IRL: 'Ireland',
  IMN: 'Isle of Man',
  ISR: 'Israel',
  ITA: 'Italy',
  JAM: 'Jamaica',
  JPN: 'Japan',
  JEY: 'Jersey',
  JOR: 'Jordan',
  KAZ: 'Kazakhstan',
  KEN: 'Kenya',
  KIR: 'Kiribati',
  PRK: 'Korea, Democratic People’s Republic of',
  KOR: 'Korea, Republic of',
  KWT: 'Kuwait',
  KGZ: 'Kyrgyzstan',
  LAO: 'Lao People’s Democratic Republic',
  LVA: 'Latvia',
  LBN: 'Lebanon',
  LSO: 'Lesotho',
  LBR: 'Liberia',
  LBY: 'Libya',
  LIE: 'Liechtenstein',
  LTU: 'Lithuania',
  LUX: 'Luxembourg',
  MAC: 'Macao',
  MDG: 'Madagascar',
  MWI: 'Malawi',
  MYS: 'Malaysia',
  MDV: 'Maldives',
  MLI: 'Mali',
  MLT: 'Malta',
  MHL: 'Marshall Islands',
  MTQ: 'Martinique',
  MRT: 'Mauritania',
  MUS: 'Mauritius',
  MYT: 'Mayotte',
  MEX: 'Mexico',
  FSM: 'Micronesia',
  MDA: 'Moldova',
  MCO: 'Monaco',
  MNG: 'Mongolia',
  MNE: 'Montenegro',
  MSR: 'Montserrat',
  MAR: 'Morocco',
  MOZ: 'Mozambique',
  MMR: 'Myanmar',
  NAM: 'Namibia',
  NRU: 'Nauru',
  NPL: 'Nepal',
  NLD: 'Netherlands',
  NCL: 'New Caledonia',
  NZL: 'New Zealand',
  NIC: 'Nicaragua',
  NER: 'Niger',
  NGA: 'Nigeria',
  NIU: 'Niue',
  NFK: 'Norfolk Island',
  MKD: 'North Macedonia',
  MNP: 'Northern Mariana Islands',
  NOR: 'Norway',
  OMN: 'Oman',
  PAK: 'Pakistan',
  PLW: 'Palau',
  PSE: 'Palestine, State of',
  PAN: 'Panama',
  PNG: 'Papua New Guinea',
  PRY: 'Paraguay',
  PER: 'Peru',
  PHL: 'Philippines',
  PCN: 'Pitcairn',
  POL: 'Poland',
  PRT: 'Portugal',
  PRI: 'Puerto Rico',
  QAT: 'Qatar',
  ROU: 'Romania',
  RUS: 'Russian Federation',
  RWA: 'Rwanda',
  REU: 'Réunion',
  BLM: 'Saint Barthélemy',
  SHN: 'Saint Helena, Ascension and Tristan da Cunha',
  KNA: 'Saint Kitts and Nevis',
  LCA: 'Saint Lucia',
  MAF: 'Saint Martin (French part)',
  SPM: 'Saint Pierre and Miquelon',
  VCT: 'Saint Vincent and the Grenadines',
  WSM: 'Samoa',
  SMR: 'San Marino',
  STP: 'Sao Tome and Principe',
  SAU: 'Saudi Arabia',
  SEN: 'Senegal',
  SRB: 'Serbia',
  SYC: 'Seychelles',
  SLE: 'Sierra Leone',
  SGP: 'Singapore',
  SXM: 'Sint Maarten (Dutch part)',
  SVK: 'Slovakia',
  SVN: 'Slovenia',
  SLB: 'Solomon Islands',
  SOM: 'Somalia',
  ZAF: 'South Africa',
  SGS: 'South Georgia and the South Sandwich Islands',
  SSD: 'South Sudan',
  ESP: 'Spain',
  LKA: 'Sri Lanka',
  SDN: 'Sudan',
  SUR: 'Suriname',
  SJM: 'Svalbard and Jan Mayen',
  SWE: 'Sweden',
  CHE: 'Switzerland',
  SYR: 'Syrian Arab Republic',
  TWN: 'Taiwan',
  TJK: 'Tajikistan',
  TZA: 'Tanzania',
  THA: 'Thailand',
  TLS: 'Timor-Leste',
  TGO: 'Togo',
  TKL: 'Tokelau',
  TON: 'Tonga',
  TTO: 'Trinidad and Tobago',
  TUN: 'Tunisia',
  TKM: 'Turkmenistan',
  TCA: 'Turks and Caicos Islands',
  TUV: 'Tuvalu',
  TUR: 'Türkiye',
  UGA: 'Uganda',
  UKR: 'Ukraine',
  ARE: 'United Arab Emirates',
  GBR: 'United Kingdom',
  UMI: 'United States Minor Outlying Islands',
  USA: 'United States of America',
  URY: 'Uruguay',
  UZB: 'Uzbekistan',
  VUT: 'Vanuatu',
  VEN: 'Venezuela',
  VNM: 'Viet Nam',
  VGB: 'Virgin Islands (British)',
  VIR: 'Virgin Islands (U.S.)',
  WLF: 'Wallis and Futuna',
  ESH: 'Western Sahara',
  YEM: 'Yemen',
  ZMB: 'Zambia',
  ZWE: 'Zimbabwe',
  ALA: 'Åland Islands',
};

export type CountryCodeType = keyof typeof CountryCodes;
